module.exports = __webpack_public_path__ + "static/media/hospital.77bfab85.png";